/** Stable key for per-row busy state (join/leave) in club lists */
export function discussionClubRowBusyKey(club) {
  if (club?.clubId) return `id:${club.clubId}`;
  const s = String(club?.slug || '').trim();
  return s ? `slug:${s}` : '';
}

/** Same key shape as {@link discussionClubRowBusyKey} for API handlers that only have slug + optional id */
export function clubBusyKeyFromSlugAndId(slug, clubId) {
  if (clubId) return `id:${clubId}`;
  const s = String(slug || '').trim();
  return s ? `slug:${s}` : '';
}

export const CLUB_LIST_META_BUSY = '__meta__';

/** @typedef {{ action: 'join' | 'leave' | 'meta', key: string } | null} ClubRowBusy */

export function clubListRowBusyProps(busy, club) {
  const rk = discussionClubRowBusyKey(club);
  const matches = !!(busy && rk && busy.key === rk);
  const rowBusy = busy?.action === 'meta' || matches;
  const rowBusyAction =
    busy?.action === 'meta' ? null : matches ? busy.action : null;
  return { rowBusy, rowBusyAction };
}
